import { render, staticRenderFns } from "./VaccineVials.vue?vue&type=template&id=336f3b9a&scoped=true"
import script from "./VaccineVials.vue?vue&type=script&lang=js"
export * from "./VaccineVials.vue?vue&type=script&lang=js"
import style0 from "./VaccineVials.vue?vue&type=style&index=0&id=336f3b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f3b9a",
  null
  
)

export default component.exports